export const getMapsLink = (address: string) => {
	const isIOS =
		/iPad|iPhone|iPod/.test(navigator.userAgent) &&
		!(window as Window & { MSStream?: unknown }).MSStream;

	if (isIOS) {
		return `maps://?q=${address}`;
	}
	return `https://maps.google.com/?q=${address}`;
};
